export const SHOPIFY_CONFIGURATION_UPDATE = '/integrations/shopify/success';
export const SHOPIFY_CONFIGURATION = '/integrations/shopify';
export const API_CONFIGURATION = '/integrations/api-public';
